import { render, staticRenderFns } from "./DeleteDialog.vue?vue&type=template&id=90803554&scoped=true"
import script from "./DeleteDialog.vue?vue&type=script&lang=ts"
export * from "./DeleteDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90803554",
  null
  
)

export default component.exports